module.exports = __webpack_public_path__ + "img/oneGreen.0db09c5a.jpg";